export var IDENTIFIER_TEXT_INPUT = 'text-input';
export var IDENTIFIER_TEXT_INPUT_ERROR = 'text-input-error';
